// cleanup_convert_to_typescript_file_SMBPYMT

import { createUseStyles } from '@glu/theming';

const styles = {
  nativeModal: {
    left: 'inherit',
    width: '95%'
  },
  challengeManagerContainer: { position: 'relative', zIndex: 1205 },
  modalNotificationContainer: { position: 'relative', zIndex: 1204 }
};

export default createUseStyles(styles);
